import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import Filter from '../components/Filter';
import ReportTable from '../components/ReportTable';
import { GridColDef } from '@mui/x-data-grid';
import { useCargo } from '../../../apis/cargo/CargoReportProvider';
import { getPageName } from '../../../locales/translationUtils';
import ExportList from '../components/ExportList';
import i18n from '../../../i18n';

const ReportListView: React.FC = () => {
  const { t } = useTranslation();
  const { cargos, apiResponse, fetchCargos } = useCargo();

  const [filters, setFilters] = useState({
    situation: "Pending",
    from: "",
    client: "",
    pageNum: "0",
    quantityPerPage: "20"
  });

  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 20,
    page: 0,
  });

  useEffect(() => {
    const newFilters = { 
      ...filters, 
      pageNum: paginationModel.page.toString(),
      quantityPerPage: paginationModel.pageSize.toString()
    };
    setFilters(newFilters);
    fetchCargos(newFilters);
  }, [paginationModel]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSituationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    fetchCargos(newFilters);
  };

  const handleSearch = () => {
    const newFilters = { 
      ...filters, 
      pageNum: "0",
      quantityPerPage: "20"
    };
    setFilters(newFilters);
    fetchCargos(newFilters);
  };

  const columns: GridColDef[] = [
    { field: 'fromIdentification', headerName: t('report.fields.fromIdentification'), width: 80 },
    { field: 'clientName', headerName: t('report.fields.clientName'), width: 120 },
    { field: 'supplierName', headerName: t('report.fields.supplierName'), width: 200 },
    { field: 'dawb', headerName: t('report.fields.dawb'), width: 100 },
    { field: 'puFormatted', headerName: t('report.fields.pickUpDateFormatted'), width: 110 },
    { field: 'arrivalFormatted', headerName: t('report.fields.arrivalDateFormatted'), width: 110 },
    { field: 'inputDateFormatted', headerName: t('report.fields.inputDateFormatted'), width: 110 },
    { field: 'poNumber', headerName: t('report.fields.poNumber'), width: 100 },
    { field: 'wrNumber', headerName: t('report.fields.wrNumber'), width: 100 },
    { field: 'invoice', headerName: t('report.fields.invoice'), width: 100 },
    { field: 'weightRaw', headerName: t('report.fields.weight'), width: 80, valueGetter: (params: any) => params?.row?.weightRaw ?? params?.row?.weight },
    { field: 'pieces', headerName: t('report.fields.pieces'), width: 80 },
    { field: 'shippedBy', headerName: t('report.fields.shippedBy'), width: 120 },
    { field: 'destination', headerName: t('report.fields.destination'), width: 120 },
    { field: 'to', headerName: t('report.fields.to'), width: 100 },
    { field: 'releasedBy', headerName: t('report.fields.releasedBy'), width: 120 },
    { field: 'releasedFormatted', headerName: t('report.fields.releasedFormatted'), width: 110 },
    { field: 'description', headerName: t('report.fields.remarks'), width: 150 },
  ];

  return (
     <Container fluid style={{ height: 'calc(90vh - 90px)', overflow: 'auto' }}>
      <h2>{getPageName('report')}</h2>
      <Filter 
        filters={filters} 
        onFilterChange={handleFilterChange} 
        onSituationChange={handleSituationChange} 
        onSearch={handleSearch} 
      />
      <ReportTable 
        apiResponse={apiResponse} 
        filters={filters} 
        rows={cargos ?? []} 
        columns={columns} 
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
      />
      <ExportList filters={filters} />
    </Container>
  );
};

export default ReportListView;